import { render, staticRenderFns } from "./rightTwo.vue?vue&type=template&id=73966d13&scoped=true&"
import script from "./rightTwo.vue?vue&type=script&lang=js&"
export * from "./rightTwo.vue?vue&type=script&lang=js&"
import style0 from "./rightTwo.vue?vue&type=style&index=0&id=73966d13&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73966d13",
  null
  
)

export default component.exports